import React, { Component } from 'react';
import XLSX from 'xlsx';
//import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { confirmAlert } from 'react-confirm-alert';

const moment = window.moment;

class ExcelReader extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            file: {},
            data: [],
            cols: [],
            sample_file_type: {},
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getFormattedDate = (date) => {
        if (date !== '' && date !== null) {
            const formattedDate = new Date(date);
            return (formattedDate.getMonth() + 1) + '/' + formattedDate.getDate() + '/' + formattedDate.getFullYear()
        } else {
            return ''
        }
    }

    warningMsg = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={"The selected file is not a valid excel file!"} onClosePro={onClose} />
                )
            }
        })
    }

    handleChange(e) {
        const files = e.target.files;
        const file = files[0];
        if (files && files[0]) this.setState({ file: files[0], sample_file_type: e.target.files[0] }, () => {
            this.handleFile();
        });
    };

    handleFile() {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        let wb;
        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            try {
                wb = XLSX.read(bstr, { type: 'binary', cellDates: true, bookVBA: true, sheetRows: 2 });
                // const wb = XLSX.read(bstr, { type: 'binary', cellDates: true, cellNF: false, cellText: false, bookVBA: true, sheetRows: 2 });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws);
                /* Update state */
                //Working for brandcsv
                const keys = Object.keys(data[0]);
                const values = Object.values(data[0]);
                const atts = [];
                if (this.props.type === 'LOOKUP') {
                    for (let i = 0; i < keys.length; i++) {
                        atts.push({
                            title: keys[i].toString(),
                            db_column: keys[i].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase().toString(),
                            sample_value: values[i] instanceof Date ? moment(values[i]).add(2, 'hours').format("DD/MM/YYYY") : values[i].toString(),
                            import_order: i + 1,
                            data_type: HF.checkClosestDatatype(values[i]).value.toString(),
                            is_key_attribute: false,
                            date_format: null,
                        })
                    }
                } else {
                    for (let i = 0; i < keys.length; i++) {
                        atts.push({
                            title: this.props.sample_file_has_header ? keys[i].trim() : '',
                            db_column: this.props.sample_file_has_header ? keys[i].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase() : '',
                            grid_label: this.props.sample_file_has_header ? keys[i] : '',
                            sample_value: values[i] instanceof Date ? moment(values[i]).add(2, 'hours').format("DD/MM/YYYY") : values[i].toString(),
                            start_position: null,
                            end_position: null,
                            show_on_grid: true,
                            is_quantity_attribute: false,
                            is_external_vendor_attr: false,
                            is_multiselect: false,
                            exportable: true,
                            searchable: false,
                            editable: false,
                            nullable: true,
                            import_order: i + 1,
                            data_type: HF.checkClosestDatatype(values[i]).value,
                            is_product_key: false,
                            default_value: '',
                            date_format: '',
                            default_value_type: null,
                        })
                    }
                }
                //End

                this.props.returnExcelAtts(atts, this.state.sample_file_type);
            } catch (e) {
                this.warningMsg();
            }
            // this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
            // console.log(this.state.data);
            // });
        };

        if (rABS) {
            reader.readAsBinaryString(this.state.file);
        } else {
            reader.readAsArrayBuffer(this.state.file);
        };
        this.fileRef.current.value = ""
    }

    render() {
        return (
            <div>
                <button className="customBtn btnBlue fileinput-button">
                    Upload Excel File
                    <input type="file"
                           ref={this.fileRef}
                           className="form-control" id="file" accept={SheetJSFT} onChange={this.handleChange} />
                </button>
            </div>

        )
    }
}

ExcelReader.defaultProps = {
    returnExcelAtts: () => { }
};

export default ExcelReader;



// WEBPACK FOOTER //
// ./src/components/Admin/ExcelReader/ExcelReader.jsx